import { BaseOptionType } from '../../../../../SingleRequestPage/components/SingleRequestDrawer/helpers/getFormSchema'
import { ChangeDataFormType } from '../hooks/useChangeEquipmentData'

export const getDefaultValues = (
  data: any,
  incidentTypes: BaseOptionType[],
): ChangeDataFormType => {
  return {
    incidentType: incidentTypes.find(
      (type) => data.incidentType === type.value,
    ) as BaseOptionType,
  }
}

export const getIsBtnDisabled = (
  defaultValues: any,
  values: ChangeDataFormType,
) => {
  const value = Object.entries(values).find(([key, value]) => {
    if (
      key === 'incidentType' &&
      defaultValues[key]?.value !== (value as BaseOptionType)?.value
    ) {
      return true
    }
  })

  return !value
}
